import React from 'react';
import {Hero} from '../components/sections/Hero';
import {About} from '../components/sections/About';
import {OngoingPromos} from '../components/sections/OngoingPromos';
import {DiningExperience} from '../components/sections/DiningExperience';
import {Connect} from '../components/sections/Connect';

export const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <OngoingPromos />
      <DiningExperience />
      <Connect />
    </>
  );
};